import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      component: HomePage,
      meta:{
        requireAuth:true
      },
      children:[
        { path: '/', redirect: '/TransitionPage' },
        {
          path: '/TransitionPage',
          name: 'TransitionPage',
          component: () => import ('../views/TransitionPage.vue')
        },
        {
          path: '/home',
          name: 'home',
          component: () => import ('../views/home.vue')
        },
        {
          path: '/QueryCus',
          name: 'QueryCus',
          component: () => import ('../views/QueryCus.vue')
        },
        {
          path: '/ContractReview',
          name: 'ContractReview',
          component: () => import ('../views/ContractReview.vue')
        },
        {
          path: '/TempNoSMS',
          name: 'TempNoSMS',
          component: () => import ('../views/ContractInfo/TempNoSMS.vue')
        },
        {
          path: '/ModuleCardTemp',
          name: 'ModuleCardTemp',
          component: () => import ('../views/ContractInfo/ModuleCardTemp.vue')
        },
        {
          path: '/ModuleTemp',
          name: 'ModuleTemp',
          component: () => import ('../views/ContractInfo/ModuleTemp.vue')
        },
        {
          path: '/postpaid',
          name: 'postpaid',
          component: () => import ('../views/ContractInfo/postpaid.vue')
        },
        {
          path: '/postpaidSMS',
          name: 'postpaidSMS',
          component: () => import ('../views/ContractInfo/postpaidSMS.vue')
        },
        {
          path: '/TempSMS',
          name: 'TempSMS',
          component: () => import ('../views/ContractInfo/TempSMS.vue')
        },
        {
          path: '/TemPurchase',
          name: 'TemPurchase',
          component: () => import ('../views/ContractInfo/TemPurchase.vue')
        },
        {
          path: '/ResultSucPage',
          name: 'ResultSucPage',
          component: () => import ('../views/ResultPage/ResultSucPage.vue')
        },
        {
          path: '/ThirdParty',
          name: 'ThirdParty',
          component: () => import ('../views/ContractInfo/ThirdParty.vue')
        },
        
        
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js